import React from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

import Text from '../Text';

/**
 * @param {object} props
 * @param {string} [props.href=''] - Link for the breadcrumb item. If not provided, the item will be rendered as plain text.
 * @param {React.ReactNode} [props.children=null] - Content of the breadcrumb item.
 */
export default function BreadcrumbItem({
  href = '',
  tone = 'default',
  children = null,
}) {
  const content = (
    <Text tone={tone} className={styles.text}>
      {children}
    </Text>
  );

  if (!href) return content;

  return (
    <Link to={href} className={styles.link}>
      {content}
    </Link>
  );
}
